import { z } from 'zod';

export const getSigninSchema = () => {
  return z.object({
    email: z
      .string()
      .min(1, { message: 'Username or email is required.' }),
    password: z
      .string()
      .optional()
      .refine((val) => !val || val.length >= 6, {
        message: 'Password must be at least 6 characters long when provided.',
      }),
    rememberMe: z.boolean().optional(),
  });
};
